import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'account/api/v1/account-balances';

const store = coreStore.queryStore(coreStore.createCoreStore('accountBalance', remoteResource));

export default store;
